import { create } from 'zustand';  

interface ReferralStore {
  referer: string | null;
  medium: string | null;
  setReferer: (referer: string | null) => void;
  setMedium: (medium: string | null) => void;
  updateReferralParams: (referer: string | null, medium: string | null) => void;
}
const useReferralStore = create<ReferralStore>((set) => ({
  referer: null,
  medium: null,
  setReferer: (referer: string | null) => set({ referer }),
  setMedium: (medium: string | null) => set({ medium }),
  updateReferralParams: (referer: string | null, medium: string | null) => {
    const currentPath = window.location.pathname;
    const searchParams = new URLSearchParams(window.location.search);
    if (referer) {
      searchParams.set('referer', referer);
    } else {
      searchParams.delete('referer');
    }
    if (medium) {
      searchParams.set('medium', medium);
    } else {
      searchParams.delete('medium');
    }
    window.history.pushState(null, '', `${currentPath}?${searchParams.toString()}`);
    set({ referer, medium });
  }
}));

export default useReferralStore;
